import React from 'react';
import { Helmet } from 'react-helmet';

interface IMetadata {
  name?: HTMLMetaElement['name'];
  rel?: HTMLLinkElement['rel'];
  type?: string;
  content: string;
  metadataTag: 'meta' | 'title' | 'link';
}

interface ISEOProps {
  metadata: IMetadata[];
}

function renderMetaTag({ name, content }: Pick<IMetadata, 'content' | 'name'>) {
  return <meta name={name} content={content} />;
}

function renderOpenGraphMetaTag({ name, content }: Pick<IMetadata, 'content' | 'name'>) {
  return <meta property={name} content={content} />;
}

function renderTitleTag({ content }: Pick<IMetadata, 'content'>) {
  return <title>{content}</title>;
}

function renderLinkTag({
  content,
  rel,
  type = '',
}: Pick<IMetadata, 'content' | 'rel' | 'type'>) {
  return <link rel={rel} href={content} type={type} />;
}

export function SEO({ metadata }: ISEOProps) {
  return (
    <Helmet>
      {metadata.map(data => {
        switch (data.metadataTag) {
          case 'title':
            return renderTitleTag(data);
          case 'link':
            return renderLinkTag(data);
          case 'meta':
            if (data.name?.includes('og:')) {
              return renderOpenGraphMetaTag(data);
            }
            return renderMetaTag(data);
          default:
            return null;
        }
      })}
    </Helmet>
  );
}
